import styled from 'styled-components';
export const Container = styled.div`
  box-sizing : border-box;
`;

export const Button = styled.button`

  color: #fff;
  background : #424242;
  height: 37px;
  min-width : 190px;
  font-size : 16px;
  text-align : center;
  padding: auto 20px;
  border : 1px solid #424242;
  box-sizing  :border-box;
  border-radius : 4px;
  cursor: pointer;
`;
export const Div = styled.div`
  background : ${props => props.background ? props.background : "#fff"};
  padding : ${props => props.padding ? props.padding : "0"};
  height: ${props => props.height ? props.height : "unset"};
  display : flex;
  justify-content : center;
  align-items : center;
`;